import { Props_SnippetImageGallery } from './ImageGallery.props';

const SnippetImageGallery = (props: Props_SnippetImageGallery) => {
    const { heading, image1, image2, image3, image4, image5 } = props;
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-image-gallery__heading--${heading.visibility.value}` : ''

    return (
        <section className="snippet-image-gallery">
            <div className="snippet-image-gallery__container">
            <h2 className={`snippet-image-gallery__heading ${classHeadingVisibility}`}>{heading.heading?.value}</h2>
                <div className="snippet-image-gallery__grid">
                    <figure className="snippet-image-gallery__image-container">
                        <img
                            loading="lazy"
                            className="snippet-image-gallery__image"
                            width="750"
                            height="520"
                            src={image1?.src?.value}
                            alt={image1?.alt?.value}
                        />
                    </figure>
                    {[image2, image3, image4, image5].map((image, index) => (
                        <figure key={index} className="snippet-image-gallery__image-container">
                            <img
                                loading="lazy"
                                src={image?.src?.value}
                                alt={image?.alt?.value}
                                className="snippet-image-gallery__image"
                                width="550"
                                height="350"
                            />
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SnippetImageGallery;